import { isEqual } from 'lodash';
import { IChartSettings, IParsedChartDataFunnel } from '../../../interfaces';
import { assertCondition } from '../../../../../utils/types';

export const getSelectedFunnelModeSlice = (
  chartData: IParsedChartDataFunnel,
  chartSettings: IChartSettings,
) => {
  // Start off measureControls to ensure that measure selection from settings is the same size as the number of
  // measures. This is important because funnelModeSlices.measureSelection by contract is that size otherwise the
  // selection from the displayed measures won't match
  // Although displayedMeasureSettings should also match the size of measures, it can be modified
  // (i.e. remove a measure by instead of setting isVisible to false) and still yield the desired result
  // (the missing measure is considered not displayed).
  const currentMeasureSelection = chartData.measureControls.map((mc) => {
    return (
      chartSettings.displayedMeasureSettings.find((dms) => dms.key === mc.key)
        ?.isVisible ?? false
    );
  });

  const funnelModeSlices = chartData.funnelModeSlices.filter((fms) =>
    // deep equals of 2 arrays
    isEqual(fms.measureSelection, currentMeasureSelection),
  );

  assertCondition(
    funnelModeSlices.length <= 1,
    `Expected exactly one or zero funnelModeSlice to match, matched ${funnelModeSlices.length}`,
  );
  const funnelModeSlice =
    funnelModeSlices.length === 0 ? undefined : funnelModeSlices[0];
  return { measureSelection: currentMeasureSelection, funnelModeSlice };
};
